import React, { createContext, useContext, useState, ReactNode } from 'react';

interface VideoBrightnessContextType {
  isVideoLight: boolean;
  setIsVideoLight: (isLight: boolean) => void;
}

const VideoBrightnessContext = createContext<VideoBrightnessContextType | undefined>(undefined);

export const useVideoBrightness = () => {
  const context = useContext(VideoBrightnessContext);
  if (context === undefined) {
    throw new Error('useVideoBrightness must be used within a VideoBrightnessProvider');
  }
  return context;
};

interface VideoBrightnessProviderProps {
  children: ReactNode;
}

export const VideoBrightnessProvider: React.FC<VideoBrightnessProviderProps> = ({ children }) => {
  const [isVideoLight, setIsVideoLight] = useState(false);

  return (
    <VideoBrightnessContext.Provider value={{ isVideoLight, setIsVideoLight }}>
      {children}
    </VideoBrightnessContext.Provider>
  );
};